module.exports = __webpack_public_path__ + "static/bannerObject2-3b2297125b7af05de353c58bb349354d.png";